module.exports = __webpack_public_path__ + "static/media/LockscreenAndroid.530b2aab.jpg";